import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

// PulseEffect component accepts a bgColor prop and applies it to the container.
export const PulseEffect = ({ bgColor }) => (
  <div
    className="pulse-effect"
    style={{ backgroundColor: bgColor || "transparent" }}
  >
    <div className="waves">
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>
    </div>
  </div>
);

const ImageShowCase = ({
  imageSrc,
  altText,
  chipText,
  withEffect,
  mixBlendModes, // expects an array, e.g. ["overlay", "overlay"]
  bgColor, // background color for the pulse-effect container
}) => {
  const chipRef = useRef(null);
  const inView = useInView(chipRef, { once: false, margin: "0px" });
  const controls = useAnimation();

  useEffect(() => {
    if (inView) {
      controls.start({
        opacity: 1,
        y: 0,
        transition: { delay: 0.5, duration: 1 },
      });
    } else {
      controls.start({
        opacity: 0,
        y: -10,
        transition: { duration: 0.5 },
      });
    }
  }, [inView, controls]);

  // If withEffect is provided, assume it's a component type.
  const EffectComponent = withEffect;

  return (
    <div className="relative inline-block">
      {withEffect && <EffectComponent bgColor={bgColor} />}
      {mixBlendModes &&
      Array.isArray(mixBlendModes) &&
      mixBlendModes.length > 0 ? (
        <>
          {/* Render the first image normally to define container size */}
          <img
            src={imageSrc}
            alt={altText}
            className="object-cover rounded-full shadow-lg relative z-10"
            style={{ mixBlendMode: mixBlendModes[0] }}
            loading="lazy"
            decoding="async"
          />
          {/* Render any additional copies absolutely on top */}
          {mixBlendModes.slice(1).map((mode, idx) => (
            <img
              key={idx}
              src={imageSrc}
              alt={altText}
              className="object-cover rounded-full shadow-lg absolute inset-0 z-10"
              style={{ mixBlendMode: mode }}
              loading="lazy"
              decoding="async"
            />
          ))}
        </>
      ) : (
        <img
          src={imageSrc}
          alt={altText}
          className="object-cover rounded-full shadow-lg relative z-10"
          style={{ mixBlendMode: mixBlendModes || "normal" }}
          loading="lazy"
          decoding="async"
        />
      )}
      {chipText && (
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <motion.div
            ref={chipRef}
            initial={{ opacity: 0, y: -10 }}
            animate={controls}
            className="bg-[#91c2cf] px-3 py-1 rounded-full text-sm font-medium shadow"
          >
            {chipText}
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default ImageShowCase;
